import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchCollectionWithPost } from '@app/src/api/fetchHooks'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import { SortOrder } from '@app/src/types/filter'
import type { ScrapedAnswer } from '@app/src/types/resourceExplorer'

interface useScrapedAnswersByResponseItemProps {
  responseItemId: number
}

const useScrapedAnswersByResponseItem = ({ responseItemId }: useScrapedAnswersByResponseItemProps) => {
  const { items: scrapedAnswers, isLoading: isLoadingScrapedAnswers } = useFetchCollectionWithPost<ScrapedAnswer>({
    key: FetchKey.ScrapedAnswer,
    endpoint: endpoints.scrapedAnswers,
    payload: {
      filter: [
        {
          name: 'responseItemId',
          filters: [
            {
              operator: Operators.EqualTo,
              value: responseItemId,
            },
          ],
        },
      ],
      include: ['citations'],
      sort: { target: 'id', order: SortOrder.ASCENDING },
    },
    options: {
      enabled: Boolean(responseItemId),
      staleTime: Infinity,
    },
  })

  const scrapedAnswer = scrapedAnswers?.[0] || null
  return {
    isLoadingScrapedAnswers,
    scrapedAnswer,
  }
}

export default useScrapedAnswersByResponseItem
